import { Component } from '@angular/core';

@Component({
  selector: 'black-zoom-documentation',
  templateUrl: './zoom-documentation.component.html',
  styleUrls: ['./zoom-documentation.component.css'],
  standalone: false,
})
export class ZoomDocumentationComponent {}
